module.exports = {"main":"build/fiverollgame.js","resources":"build/resources/","version":"1.1.8 Fri Aug 23 2024 06:49:47 GMT-0400 (Eastern Daylight Time)","replace":{"rules":["PIXI"],"prefix":"5_ROLL_"},"settings":{"resourcesRoot":"build/resources"},"language":"en"}


//////////////////
// WEBPACK FOOTER
// ./gamecfg.json
// module id = 14
// module chunks = 0